import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2cca7009")

_pushScopeId("data-v-2cca7009")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-d-flex p-flex-row p-ai-center scorecards-target-container" }
const _hoisted_3 = { class: "p-d-flex p-ai-center p-ml-5" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "fa fa-bullseye fa-lg p-mr-1 scorecard-blue-icon" }, null, -1)
const _hoisted_5 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_6 = { class: "p-ml-auto" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "p-d-flex p-flex-row p-ai-center scorecards-kpi-container"
}
const _hoisted_9 = { class: "scorecards-kpi-info" }
const _hoisted_10 = { class: "p-ml-auto" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_InputText = _resolveComponent("InputText")
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_ScorecardsTableHint = _resolveComponent("ScorecardsTableHint")
  const _component_ScorecardsKpiDialog = _resolveComponent("ScorecardsKpiDialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_ctx.target)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            (!_ctx.expanded)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  icon: "fas fa-chevron-right",
                  class: "p-button-text p-button-rounded p-button-plain",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expanded = true))
                }))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  icon: "fas fa-chevron-down",
                  class: "p-button-text p-button-rounded p-button-plain",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.expanded = false))
                })),
            _hoisted_4,
            _createVNode(_component_InputText, {
              class: "kn-material-input scorecards-target-name-input",
              modelValue: _ctx.target.name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.target.name = $event)),
              maxLength: 40,
              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('touched', false)))
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_SelectButton, {
              class: "p-mr-1",
              modelValue: _ctx.selectedCriteria,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedCriteria = $event)),
              options: _ctx.descriptor.criteriaOptions,
              onChange: _ctx.onCriteriaChange
            }, {
              option: _withId((slotProps) => [
                _withDirectives(_createVNode("span", {
                  "data-test": 'select-button-' + slotProps.option
                }, [
                  _createTextVNode(_toDisplayString(slotProps.option), 1)
                ], 8, ["data-test"]), [
                  [_directive_tooltip, _ctx.getSelectedCriteriaTooltip(slotProps.option, _ctx.$t)]
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "options", "onChange"]),
            (_ctx.selectedCriteria !== 'M')
              ? (_openBlock(), _createBlock(_component_MultiSelect, {
                  key: 0,
                  style: _ctx.descriptor.style.multiselect,
                  modelValue: _ctx.target.options.criterionPriority,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.target.options.criterionPriority = $event)),
                  options: _ctx.target.kpis,
                  optionLabel: "name",
                  optionValue: "name",
                  onChange: _ctx.onCriterionPriortyChanged,
                  "data-test": "criteria-select-input"
                }, null, 8, ["style", "modelValue", "options", "onChange"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_6, [
            _withDirectives(_createVNode(_component_Button, {
              icon: "fa-solid fa-square-plus",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _ctx.openKpiDialog
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('managers.scorecards.addKpi'),
                void 0,
                { top: true }
              ]
            ]),
            _createVNode(_component_Button, {
              icon: "fas fa-trash-alt",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _ctx.deleteTargetConfirm
            }, null, 8, ["onClick"])
          ])
        ]),
        (_ctx.expanded)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              (_ctx.target.kpis.length === 0)
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode(_component_ScorecardsTableHint, { hint: 'managers.scorecards.addKpiHint' }, null, 8, ["hint"])
                  ]))
                : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.target.kpis, (kpi, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: "p-d-flex p-flex-row p-ai-center scorecards-kpi-container"
                    }, [
                      _createVNode("div", _hoisted_9, [
                        _createVNode("i", {
                          class: ["fas fa-square fa-2xl p-mr-2", _ctx.getKpiIconColorClass(kpi)]
                        }, null, 2),
                        _createVNode("span", null, _toDisplayString(kpi.name), 1)
                      ]),
                      _createVNode("div", _hoisted_10, [
                        _createVNode(_component_Button, {
                          icon: "fas fa-trash-alt",
                          class: "p-button-text p-button-rounded p-button-plain",
                          onClick: ($event: any) => (_ctx.deleteKpiConfirm(kpi))
                        }, null, 8, ["onClick"])
                      ])
                    ]))
                  }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_ScorecardsKpiDialog, {
          visible: _ctx.kpiDialogVisible,
          propKpis: _ctx.kpis,
          selectedKpis: _ctx.target.kpis,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.kpiDialogVisible = false)),
          onKpiSelected: _ctx.onKpiSelected
        }, null, 8, ["visible", "propKpis", "selectedKpis", "onKpiSelected"])
      ]))
    : _createCommentVNode("", true)
})